export default "__VITE_ASSET__Td_VyTUK__"